import { translate } from 'loankeeper-common/helpers'

export const translateWM = (name) => translate(`frm_web_messages-${name}`)
